import { connect } from 'react-redux';
import { compose } from 'redux';
import _ from 'underscore';

import { filterOnMultipleFields } from '../../helpers/arrayHelpers';

import Categories from '../../categories';

import withSelected from './withSelected';

const filterData = (list, searchString) => {
  const regexp = new RegExp(searchString, 'i');
  const keys = ['categoryDescription', 'cpdCourse', 'categoryCode'];
  return searchString === ''
    ? list
    : filterOnMultipleFields(list, keys, regexp);
};

const formatDataTable = (list = [], selected) => {
  const dataTable = list.map((rowData) => {
    const selectedIDs = _.keys(selected);
    return {
      row: {
        selectable: true,
        checked: _.contains(selectedIDs, rowData.categoryCode),
        id: rowData.categoryCode,
      },
      cells: [
        { text: rowData.categoryDescription },
        { text: rowData.categoryCode },
        { text: rowData.cpdCourse },
      ],
      item: rowData,
    };
  });

  return dataTable;
};

const mapStateToProps = ({ search = {} }, { Selected = {} }) => {
  const { searchString = '' } = search;
  const dataRows = filterData(Categories.rows, searchString);

  const data = formatDataTable(dataRows, Selected);
  return { data };
};

export default (WrappedComponent) => compose(
  withSelected,
  connect(mapStateToProps, null),
)(WrappedComponent);
